export default "__VITE_ASSET__DrALsQjr__"